import React, { useState } from "react";
import Header from "./Header";

const Register = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleRegister = (e) => {
        e.preventDefault();
        alert(`Registrasi dengan email: ${email}`);
    };

    return (
        <div className="container">
            <Header />
            <h2>Register</h2>
            <form onSubmit={handleRegister}>
                <input type="email" placeholder="Email" className="form-control mb-2"
                    value={email} onChange={(e) => setEmail(e.target.value)} required />
                <input type="password" placeholder="Password" className="form-control mb-2"
                    value={password} onChange={(e) => setPassword(e.target.value)} required />
                <button type="submit" className="btn btn-success">Register</button>
            </form>
        </div>
    );
};

export default Register;
